// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"159":"83b051ea","279":"cd91a04c","959":"fe8d0a29"}[chunkId] + ".css";
};